import type { ComponentType } from 'preact';

import type {
  DefaultTemplateRootProps,
  RepeaterFunctionInvoker,
  RepeaterRow,
  RepeaterRowProps,
  TemplateResult,
} from 'Components/types';

export default function createRepeaterComponents<
  Params,
  Item,
  Key extends string,
  RootProps extends object = DefaultTemplateRootProps,
  RootElement extends HTMLElement = HTMLElement,
>(
  items: readonly Item[],
  keyName: Key,
  Row: RepeaterRow<Params, Item, Key, RootProps, RootElement>,
  getKey: (item: Item) => string | number,
): RepeaterFunctionInvoker<Params, RootProps, RootElement> {
  const RowComponent = Row as ComponentType<RepeaterRowProps<Params, Item, Key, RootProps, RootElement>>;

  return items.map((item) => (template) => {
    const props = {
      template,
      [keyName]: item,
    } as RepeaterRowProps<Params, Item, Key, RootProps, RootElement>;

    return (<RowComponent {...props} key={String(getKey(item))} />) as TemplateResult<RootProps, RootElement>;
  });
}
